import { z } from "zod";
import { CycleDeliveryStates, CycleRevieweeStates } from "../reviewCycleSchemas.ts";

export const CycleReviewStatusFilters = ["not-started", "in-progress", "submitted"] as const;

export type CycleReviewStatusFilter = (typeof CycleReviewStatusFilters)[number];

export const CycleRevieweeExceptions = ["no-manager", "no-peer-reviewers", "no-upward-reviewers", "deactivated"] as const;

export type CycleRevieweeException = (typeof CycleRevieweeExceptions)[number];

const ReviewStatusFilterSchema = z.array(z.enum(CycleReviewStatusFilters)).optional();

export const RosterFiltersSchema = z.object({
    searchTerm: z.string().optional(),
    selfReviewStatuses: ReviewStatusFilterSchema,
    managerReviewStatuses: ReviewStatusFilterSchema,
    peerReviewStatuses: ReviewStatusFilterSchema,
    upwardReviewStatuses: ReviewStatusFilterSchema,
    deliveryStates: z.array(z.enum(CycleDeliveryStates)).optional(),
    exceptions: z.array(z.enum(CycleRevieweeExceptions)).optional(),
    revieweeStates: z.array(z.enum(CycleRevieweeStates)).optional()
});

export type RosterFilters = z.infer<typeof RosterFiltersSchema>;

export const ScopeRosterFiltersSchema = RosterFiltersSchema.omit({ searchTerm: true, revieweeStates: true });
